import '@testing-library/jest-dom';
import { fireEvent, render, screen } from '@testing-library/react';
import { BrowserRouter, Routes, Route } from 'react-router';

import type { ReactNode } from 'react';

import { LinkButton } from './LinkButton';

const routerContainer = ({ children }: { children: ReactNode }) => (
  <BrowserRouter>
    <Routes>
      <Route path={`/`} element={<div>Test route</div>} />
    </Routes>
    {children}
  </BrowserRouter>
);

describe('LinkButton', () => {
  it('should render', () => {
    render(
      routerContainer({
        children: (
          <LinkButton variant="primary" to={'/'}>
            Test LinkButton
          </LinkButton>
        ),
      })
    );
    expect(screen.getByText('Test LinkButton')).toBeInTheDocument();
  });

  it('should render primary', () => {
    render(
      routerContainer({
        children: (
          <LinkButton variant="primary" to={'/'}>
            Test LinkButton
          </LinkButton>
        ),
      })
    );
    expect(screen.getByText('Test LinkButton')).toBeInTheDocument();
    expect(screen.getByText('Test LinkButton')).toHaveClass('button--primary');
  });

  it('should render secondary', () => {
    render(
      routerContainer({
        children: (
          <LinkButton variant="secondary" to={'/'}>
            Test LinkButton
          </LinkButton>
        ),
      })
    );
    expect(screen.getByText('Test LinkButton')).toBeInTheDocument();
    expect(screen.getByText('Test LinkButton')).toHaveClass('button--secondary');
  });

  it('should render destructive-primary', () => {
    render(
      routerContainer({
        children: (
          <LinkButton variant="destructive-primary" to={'/'}>
            Test LinkButton
          </LinkButton>
        ),
      })
    );
    expect(screen.getByText('Test LinkButton')).toBeInTheDocument();
    expect(screen.getByText('Test LinkButton')).toHaveClass('button--destructive-primary');
  });

  it('should render destructive-secondary', () => {
    render(
      routerContainer({
        children: (
          <LinkButton variant="destructive-secondary" to={'/'}>
            Test LinkButton
          </LinkButton>
        ),
      })
    );
    expect(screen.getByText('Test LinkButton')).toBeInTheDocument();
    expect(screen.getByText('Test LinkButton')).toHaveClass('button--destructive-secondary');
  });

  it('should render blank', () => {
    render(
      routerContainer({
        children: (
          <LinkButton variant="blank" to={'/'}>
            Test LinkButton
          </LinkButton>
        ),
      })
    );
    expect(screen.getByText('Test LinkButton')).toBeInTheDocument();
    expect(screen.getByText('Test LinkButton')).toHaveClass('button--blank');
  });

  it('should render blank-subtle', () => {
    render(
      routerContainer({
        children: (
          <LinkButton variant="blank-subtle" to={'/'}>
            Test LinkButton
          </LinkButton>
        ),
      })
    );
    expect(screen.getByText('Test LinkButton')).toBeInTheDocument();
    expect(screen.getByText('Test LinkButton')).toHaveClass('button--blank-subtle');
  });

  it('should render blank-icon', () => {
    render(
      routerContainer({
        children: (
          <LinkButton variant="blank-icon" to={'/'}>
            Test LinkButton
          </LinkButton>
        ),
      })
    );
    expect(screen.getByText('Test LinkButton')).toBeInTheDocument();
    expect(screen.getByText('Test LinkButton')).toHaveClass('button--blank-icon');
  });

  it('should goto route when clicked', () => {
    render(
      routerContainer({
        children: (
          <LinkButton variant="primary" to={'/'}>
            Test LinkButton
          </LinkButton>
        ),
      })
    );
    fireEvent.click(screen.getByText('Test LinkButton'));
    expect(screen.getByText('Test route')).toBeInTheDocument();
  });
});
